module.exports = __webpack_public_path__ + "img/login.258b5cc7.jpg";